export default "__VITE_ASSET__CEZ3xzCg__"